/* eslint-disable react/no-danger */
import type { Announcement } from 'common/models';
import Button from 'components/Button/Button';
import FlexRow from 'components/FlexRow/FlexRow';
import Modal from 'components/Modal/Modal';
import ModalFooter from 'components/Modal/ModalFooter';
import { sanitizeHtml } from 'helpers/htmlHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface Props {
  announcement: Announcement;
  onDismiss: () => void;
}

const AnnouncementModal: React.FC<Props> = (props): React.ReactElement => {
  const { announcement, onDismiss } = props;

  const { t } = useCustomTranslation();

  return (
    <Modal onClose={onDismiss} open={!announcement.isDismissed} title={announcement.title}>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(announcement.htmlContent) }} />
      <ModalFooter>
        <FlexRow right noMargin>
          <Button onClick={onDismiss} type="link">
            {t('announcement.continue')}
          </Button>
        </FlexRow>
      </ModalFooter>
    </Modal>
  );
};

export default AnnouncementModal;
